import { useCallback } from 'react';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import NextImage from '@base/Image';
import {
  Wrapper,
  ButtonWrapper,
  Info,
  Details,
  Title,
  NotifiedMeCTAWrapper
} from './WebNotifyMe';
import useNotifyMe from '../useNotifyMe';
import notificationsType from '../constants';

const NotifyMeOnPriceCardWrapper = styled(Wrapper)`
  display: flex;
  grid-column: 17/25;
  flex-direction: column;
  width: 100%;
  min-height: 270px;
  padding: ${Spacings.SPACING_6B};
  margin: ${Spacings.SPACING_0B};
`;

const StylesDetails = styled(Details)`
  padding-top: ${Spacings.SPACING_4B};
  padding-bottom: ${Spacings.SPACING_6B};
`;

const StyledIconWrapper = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
`;

const WebNotifyMeOnPriceCard = () => {
  const {
    sendNotifyMeRequest,
    notifiedNotification = {},
    notifyMeInfo,
    isNotifyRequested
  } = useNotifyMe();
  const { onPriceCard } = notifyMeInfo;
  const isNotified = notifiedNotification[notificationsType.UPCOMING_BATCHES];

  const handleClick = useCallback(() => {
    sendNotifyMeRequest({
      notification_type: notificationsType.UPCOMING_BATCHES,
      is_active: !isNotified,
      touchPoint: 'Page Footer'
    });
  }, [isNotified, sendNotifyMeRequest]);

  return (
    <NotifyMeOnPriceCardWrapper>
      <StyledIconWrapper>
        <NextImage src="special-class.svg" alt="notify-me" layout="fill" />
      </StyledIconWrapper>
      <StylesDetails>
        <Title>{onPriceCard.title}</Title>
        <Info>{onPriceCard.subtitle}</Info>
      </StylesDetails>
      <ButtonWrapper $fullWidth>
        <NotifiedMeCTAWrapper
          isNotified={isNotified}
          onClick={handleClick}
          fullWidth
          isNotifyRequested={isNotifyRequested}
        />
      </ButtonWrapper>
    </NotifyMeOnPriceCardWrapper>
  );
};

export default WebNotifyMeOnPriceCard;
